import { render, staticRenderFns } from "./FeedbackDialog.vue?vue&type=template&id=f05ba7be&scoped=true"
import script from "./FeedbackDialog.vue?vue&type=script&lang=js"
export * from "./FeedbackDialog.vue?vue&type=script&lang=js"
import style0 from "./FeedbackDialog.vue?vue&type=style&index=0&id=f05ba7be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05ba7be",
  null
  
)

export default component.exports